import * as Yup from 'yup';
import { FunctionariesSwitch } from '../../../../../../shared/types/systemConfiguration/functionariesSwitch';

export const initialValues: FunctionariesSwitch = {
    name: '',
    surname: '',
    email: '',
    phone: '',
    extension: '',
    active: true,
    description: '',
    area: '',
    city: '',
    position: '',
};

export const validationSchema = () =>
    Yup.object<FunctionariesSwitch>().shape({
        name: Yup.string()
            .trim()
            .required('El nombre es obligatorio')
            .max(150, 'Máximo 150 caracteres'),
        surname: Yup.string()
            .trim()
            .required('El apellido es obligatorio')
            .max(150, 'Máximo 150 caracteres'),
        email: Yup.string()
            .trim()
            .email('Correo inválido')
            .required('El correo es obligatorio'),
        phone: Yup.string()
            .trim()
            .required('El teléfono es obligatorio')
            .max(10, 'Máximo 10 caracteres'),
        extension: Yup.string()
            .trim()
            .required('La extensión es obligatoria')
            .max(10, 'Máximo 10 caracteres'),
        active: Yup.boolean().required('El estado activo es obligatorio'),
        area: Yup.string()
            .uuid('Área inválida')
            .required('El área es obligatoria'),
        city: Yup.string()
            .transform((v) => (v === '' ? undefined : v))
            .uuid('Ciudad inválida')
            .notRequired(),
        position: Yup.string()
            .uuid('Cargo inválido')
            .required('El cargo es obligatorio'),
    });
